<template>
    <div>
        <v-checkbox
            v-model="filter.status"
            color="#009688"
            dense
        >
            <template #label>
                <span style="font-weight: 500; color: black;">Filter Affiliated Doctors by Specialization</span>
            </template>
        </v-checkbox>
        <v-expand-transition>
            <div v-show="filter.status">
                <v-alert
                    dense
                    outlined
                    type="info"
                    color="#003566"
                    elevation="2"
                >
                    This will filter the doctors at <strong>{{ data.from.hosp.hosp_name }}</strong> with the selected specialization.
                </v-alert>
                <v-autocomplete
                    v-if="getSpecializations.length > 0"
                    ref="filterFromSpecialFieldVal"
                    v-model="filter.fieldVal"
                    style="margin-bottom: 15px;"
                    hide-details
                    clearable
                    :items="getSpecializations"
                    item-text="sp_name"
                    :auto-select-first="true"
                    return-object
                    @click:clear="resetFilterFromSpecialFieldVal"
                >
                    <template #label>
                        <span style="font-weight: 500; color: black;">Specialization</span>
                    </template>
                </v-autocomplete>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['data'],
    data: ()=>({
        filter: {
            status: false,
            fieldVal: ''
        }
    }),
    computed: {
        ...mapGetters(['getSpecializations'])
    },
    watch: {
        'filter.fieldVal': {
            async handler(newVal) {
                if (newVal) {
                    this.filter.fieldVal.sp_desc = newVal.sp_desc
                    this.filter.fieldVal.sp_name = newVal.sp_name
                    this.$emit('resetDoctor')
                    const PROVIDER_ID       = this.data.from.hosp.hosp_msu_code
                    const SPECIALIZATION    = newVal.sp_desc
                    await this.getProviderAffiDoctors({ PROVIDER_ID, SPECIALIZATION })
                } else {
                    this.resetFilterFromSpecialFieldVal()
                }
                this.$nextTick(()=>{
                    this.changeColor('searchDoctor', 'doctor')
                })
            }
        },
        'filter.status': {
            handler(newVal) {
                if (!newVal) {
                    this.resetFilterFromSpecialFieldVal()
                } else {
                    if (this.getSpecializations.length > 0)
                        this.filter.fieldVal = this.getSpecializations[0]
                }
            }
        }
    },
    methods: {
        ...mapActions(['getProviderAffiDoctors']),
        changeColor(refName, colorKey) {
            this.$nextTick(() => {
                if (this.$refs && this.$refs[refName])
                    this.$refs[refName].validate() ? this.color[colorKey] = 'black' : this.color[colorKey] = 'red'
            })
        },
        resetFilterFromSpecialFieldVal() {
            this.$nextTick(()=>{
                if (this.$refs&&this.$refs.filterFromSpecialFieldVal) this.$refs.filterFromSpecialFieldVal.blur()
                this.filter.fieldVal  = { sp_desc: '', sp_name: '' }
                this.$emit('resetDoctor')
            })
        }
    }
}
</script>
